<script lang="ts">
  import { onMount } from "svelte";
  import { isUserRoleADM } from "../../app.store";
  import ActionMenu from "../../components/ActionMenu.svelte";
  import ActivityTypeDropdown from "../../components/Business/ActivityTypeDropdown.svelte";
  import CustomerDropdown from "../../components/Business/CustomerDropdown.svelte";
  import DossierDropdown from "../../components/Business/DossierDropdown.svelte";
  import PortalUserDropdown from "../../components/Business/PortalUserDropdown.svelte";
  import Button from "../../components/Button.svelte";
  import DateInput from "../../components/Form/Fields/DateInput.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import Label from "../../components/Form/Label.svelte";
  import Icon from "../../components/Icon.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { formatCurrency } from "../../utils/date-utils";
  import { activityDtoFields } from "../../utils/TableFields/activity-dto.fields";
  import {
    loading,
    records,
    pagination,
    initList,
    onCreate,
    onEdit,
    onDelete,
    onPageChange,
    onExport,
    onGeneralExport,
    filter,
    search,
    stats,
    bulkChangeInvoicingStatus,
  } from "./activity.store";

  function onCustomerSelect(event: CustomEvent) {
    $filter.criteria.dossierId = null;
    search();
  }

  onMount(initList);
</script>

<MainLayout>
  <div class="columns fit">
    <div class="column is-9">
      <SearchHeader
        entitySingular="attività"
        entityPlural="attività"
        searchPlaceholder="cerca per titolo"
        numRecords={$pagination != null ? $pagination.totalRecords : 0}
        searchFieldVisible={false}
        bind:searchValue={$filter.criteria.query}
        on:search={search}
      >
        <div class="level-item" slot="search">
          <div class="field" style="margin-right:10px;margin-bottom:0">
            <p class="control" style="min-width:300px">
              <CustomerDropdown
                name=""
                placeholder="cliente"
                required={false}
                clearVisible={true}
                bind:value={$filter.criteria.customerId}
                on:select={onCustomerSelect}
                on:clear={onCustomerSelect}
              />
            </p>
          </div>
          <div class="field">
            <p class="control" style="min-width:300px">
              <DossierDropdown
                name=""
                placeholder="pratica"
                required={false}
                clearVisible={true}
                customerId={$filter.criteria.customerId || 0}
                bind:value={$filter.criteria.dossierId}
                on:select={search}
                on:clear={search}
              />
            </p>
          </div>
        </div>

        <div class="level-right" slot="additional">
          <div class="level-item">
            <ActionMenu title="Modifica stato fatturazione">
              <a href="#top" class="dropdown-item" on:click={(_) => bulkChangeInvoicingStatus(true)}>Tutte fatturate</a>
              <a href="#top" class="dropdown-item" on:click={(_) => bulkChangeInvoicingStatus(false)}>Tutte da fatturare</a>
            </ActionMenu>
          </div>
        </div>

        <div class="columns">
          <div class="column is-2">
            <FormField>
              <DateInput name="Da data" placeholder="da data" bind:value={$filter.criteria.dateFrom} />
            </FormField>
          </div>
          <div class="column is-2">
            <FormField>
              <DateInput name="A data" placeholder="a data" bind:value={$filter.criteria.dateTo} />
            </FormField>
          </div>

          <div class="column">
            <FormField>
              <ActivityTypeDropdown name="Causale Attività" required={false} clearVisible={true} bind:value={$filter.criteria.activityTypeId} />
            </FormField>
          </div>
          <div class="column">
            <FormField>
              <PortalUserDropdown name="Utente" required={false} clearVisible={true} bind:value={$filter.criteria.portalUserId} />
            </FormField>
          </div>
        </div>

        <div class="columns">
          <div class="column is-2">
            <FormField>
              <Switch name="Con costi" bind:value={$filter.criteria.costs} />
            </FormField>
          </div>
          <div class="column is-2">
            <FormField>
              <Switch name="Da fatturare" bind:value={$filter.criteria.toBill} />
            </FormField>
          </div>
          <div class="column is-4">
            <FormField>
              <ClfDropdown name="Tipo Cliente" schema="CUSTMRTYPE" required={false} clearVisible={true} bind:value={$filter.criteria.clfCustomerTypeId} />
            </FormField>
          </div>

          <div class="column is-2">
            <FormField>
              <div>
                <Label><span>&nbsp;</span></Label>
                <Button on:click={search}>
                  <Icon name="search" />
                  <span>Cerca</span>
                </Button>
              </div>
            </FormField>
          </div>

          <div class="column is-2">
            {#if $isUserRoleADM}
              <FormField>
                <div>
                  <Label><span>&nbsp;</span></Label>
                  <Button on:click={onGeneralExport}>
                    <Icon name="download_file" />
                    <span>Riepilogo Generale</span>
                  </Button>
                </div>
              </FormField>
            {/if}
          </div>

          <!--
          <div class="column is-2">
            <div class="general-search-button-container">
              <Button on:click={search}>
                <Icon name="search" />
                <span>Cerca</span>
              </Button>
            </div>
          </div>

          <div class="column is-4">
            {#if $isUserRoleADM}
              <div class="general-export-button-container">
                <Button on:click={onGeneralExport}>
                  <Icon name="download_file" />
                  <span>Riepilogo Generale</span>
                </Button>
              </div>
            {/if}
          </div>
          -->
        </div>
      </SearchHeader>
    </div>

    <div class="column is-3">
      <div class="box">
        <h1 class="subtitle">Riepilogo</h1>
        {#if $stats}
          <p>Tempo totale: {$stats.totalTime}</p>
          <p>Tempo medio attività: {$stats.avgActivityTime}</p>
          <p>Costi anticipati: {formatCurrency($stats.costsAmount)}</p>
          <p>Pratiche in corso: {$stats.numDossiers}</p>
          <p>Numero attività: {$stats.numActivities}</p>
          <p>Numero utenti: {$stats.numUsers}</p>
        {:else}
          <p>Tempo totale: --:--</p>
          <p>Tempo medio attività: --:--</p>
          <p>Costi anticipati: € 0.00</p>
          <p>Pratiche in corso: 0</p>
          <p>Numero attività: 0</p>
          <p>Numero utenti: 0</p>
        {/if}
      </div>
    </div>
  </div>

  <Table
    loading={$loading}
    fields={activityDtoFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    exportEnabled={$isUserRoleADM}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
    on:export={(_) => onExport()}
  />
</MainLayout>

<style>
  .fit {
    height: fit-content;
  }
  .general-export-button-container {
    text-align: right;
    margin-top: 26px;
  }
  .general-search-button-container {
    text-align: right;
    margin-top: 26px;
  }
</style>
